import { Blue, Gray, Main, White } from '@constants/color';
import { css } from '@emotion/react';

export const container = css({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0px 40px',
  columnGap: '40px',
  height: '120px',
  minHeight: '120px',
  backgroundColor: 'rgba(17, 23, 35, 0.5)',
  border: '4px solid transparent',
  borderRadius: '8px',
  color: '#ffffff',
  fontSize: '24px',
  fontWeight: 500
});
export const focusedContainer = css({
  borderWidth: '4px',
  borderStyle: 'solid',
  borderColor: Main.priBlue
});

export const leftContainer = css({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  columnGap: '40px'
});
export const rightContainer = css({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  columnGap: '40px'
});
export const doctorContainer = css({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  columnGap: '20px',
  color: Gray.Gray60
});

export const patientName = css({
  width: '120px',
  fontSize: '28px',
  color: White.White10
});
export const departmentName = css({
  width: '160px',
  fontSize: '28px',
  color: White.White10
});
export const doctorName = css({
  fontSize: '28px',
  minWidth: '100px',
  color: White.White10Alpha60
});
export const hospitalName = css({
  fontSize: '28px',
  color: White.White10Alpha60
});
export const treatmentEndedAt = css({
  fontSize: '24px',
  color: White.White10Alpha60
});

// TODO: duplicates with global button style
export const prescriptionContainer = css({
  display: 'flex',
  flexDirection: 'row',
  width: '120px',
  height: '48px'
});

export const button = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  borderRadius: '4px',
  fontSize: '20px',
  fontWeight: 500,
  backgroundColor: 'rgba(0, 115, 250, 0.1)',
  color: Blue.Blue40
});

export const emphasis = css({
  backgroundColor: Main.priBlue,
  color: White.White10
});
